module.exports = __webpack_public_path__ + "static/images/tutorial-3.c7914880f08391f8142543d73650934d.svg";